module.exports = __webpack_public_path__ + "img/DisconnectedSockets.cba638bb.svg";